import React, { Component } from "react";
import { Table, Pagination, Col, Row, Input } from "antd";
import { strings } from "../../helpers";
import { Link } from "react-router-dom";
const { Search } = Input;

export default class PharmacyListView extends Component {
  render() {
    const {
      pharmacyList,
      allRecords,
      pageNo,
      onPageChange,
      searchText,
      handleSearchText,
      handleSearch,
      stateName,
      handleStateChange,
      handleStateSearch,
      navigateToPharmacyDetails
    } = this.props;

    const columns = [
      {
        title: "Name",
        key: "name",
        align: "left",
        render: record => (
          <Link to={`/pharmacy-details/${record.id}/basic-details`}>
            {record.name || "--"}
          </Link>
        )
      },
      {
        title: "email",
        key: "email",
        align: "left",
        render: record => <div>{record.email || "--"}</div>
      },
      {
        title: "phone number",
        key: "phone_number",
        align: "left",
        render: record => <div>{record.phone_number || "--"}</div>
      },
      {
        title: "town/city",
        key: "city",
        align: "left",
        render: record => <div>{record.location.city || "--"}</div>
      },
      {
        title: "state",
        key: "state",
        align: "left",
        render: record => <div>{record.location.state || "--"}</div>
      }
    ];
    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={5} className="heading-domain">
              {strings.dashboard.pharmacy}
            </Col>
            <Col span={19}>
              <Row type="flex" justify="end" align="middle" gutter={18}>
                <Col span={12}>
                  <label>{strings.dashboard.searchBy}</label>
                  <Search
                    className="mt-7"
                    value={searchText}
                    onChange={handleSearchText}
                    placeholder={strings.dashboard.searchByClinicPlaceholder}
                    onSearch={handleSearch}
                    onPressEnter={handleSearch}
                    allowClear
                  />
                </Col>
                <Col span={12}>
                  <label>{strings.dashboard.searchBy}</label>
                  <Search
                    className="mt-7"
                    value={stateName}
                    onChange={handleStateChange}
                    placeholder={strings.dashboard.searchByStatePlaceholder}
                    onSearch={handleStateSearch}
                    onPressEnter={handleStateSearch}
                    allowClear
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x">
            <Table
              columns={columns}
              dataSource={pharmacyList}
              pagination={false}
              rowKey="id"
              // onRow={(record, rowIndex) => {
              //   return {
              //     onClick: event => {
              //       navigateToPharmacyDetails(event, record.id);
              //     } // click row
              //   };
              // }}
            />
          </div>
        </div>
        <div className="pagination-wrapper">
          {allRecords > 10 && (
            <div className="total-results-wrap">
              <span className="result-count">{allRecords}</span>
              {allRecords > 1 ? strings.results : strings.result}
            </div>
          )}
          {allRecords > 10 && (
            <Pagination
              total={allRecords}
              current={pageNo}
              onChange={onPageChange}
              pageSize={10}
              defaultCurrent={pageNo}
            />
          )}
        </div>
      </div>
    );
  }
}
